import { Typography, Paper } from '@mui/material'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'
import { useTranslation } from 'react-i18next'

const CheckCreditRisk = ({ creditRiskCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = creditRiskCheck?.checkDetails
  const found = details?.found


  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:creditRiskCompany')}</Typography>
        <CheckRiskStatus checkLength={found ? 1 : 0} hasChecks={found} />
      </Paper>

      <CheckDetailTitle
        email={creditRiskCheck?.email}
        status={creditRiskCheck?.status}
        createdAt={creditRiskCheck?.createdAt}
        updatedAt={creditRiskCheck?.updatedAt}
      />

      {found ? (
        <TimelineDotLine>
          <Paper elevation={0} variant="rootOutlined" sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 2 }}>
              Información del Documento
            </Typography>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">ID Trámite Principal</Typography>
                <Typography variant="subtitle3">{details?.id_tramite_principal || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">ID Tarjeta Reimpresa</Typography>
                <Typography variant="subtitle3">{details?.id_tramite_tarjeta_reimpresa || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Ejemplar</Typography>
                <Typography variant="subtitle3">{details?.ejemplar || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Vencimiento</Typography>
                <Typography variant="subtitle3">{details?.vencimiento || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Emisión</Typography>
                <Typography variant="subtitle3">{details?.emision || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">CUIL</Typography>
                <Typography variant="subtitle3">{details?.cuil || '---'}</Typography>
              </div>
            </div>

            <Typography variant="subtitle2" sx={{ mt: 4, mb: 2 }}>
              Datos Personales
            </Typography>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">Nombre</Typography>
                <Typography variant="subtitle3">{details?.nombres || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Apellido</Typography>
                <Typography variant="subtitle3">{details?.apellido || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Fecha de Nacimiento</Typography>
                <Typography variant="subtitle3">{details?.fecha_nacimiento || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Nacionalidad</Typography>
                <Typography variant="subtitle3">{details?.nacionalidad || '---'}</Typography>
              </div>
            </div>

            <Typography variant="subtitle2" sx={{ mt: 4, mb: 2 }}>
              Dirección
            </Typography>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">Calle</Typography>
                <Typography variant="subtitle3">{details?.calle || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Número</Typography>
                <Typography variant="subtitle3">{details?.numero || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Ciudad</Typography>
                <Typography variant="subtitle3">{details?.ciudad || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Provincia</Typography>
                <Typography variant="subtitle3">{details?.provincia || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">País</Typography>
                <Typography variant="subtitle3">{details?.pais || '---'}</Typography>
              </div>
            </div>

            <Typography variant="subtitle2" sx={{ mt: 4, mb: 1 }}>
              Mensaje del Renaper
            </Typography>
            <Typography variant="subtitle3">{details?.mensaje || '---'}</Typography>
          </Paper>
        </TimelineDotLine>
      ) : (
        <Paper variant="rootOutlined" elevation={0}>
          <Typography variant="subtitle3">No se encontraron datos.</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {creditRiskCheck?.checkDetails?.info || t('common:noInfoAvailable')}
          </Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckCreditRisk

/* import { Box, Typography, Grid, Divider } from '@mui/material'
import CheckDetailTitle from './components/CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckCreditRisk = ({ title = '', creditRiskCheck, level = 0 }) => {
  const details = creditRiskCheck?.checkDetails

  if (creditRiskCheck?.checkDetails?.found === false) {
    return (
      <Box className="detail-group" sx={{ padding: '1.5rem' }}>
        <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1rem' }}>
          {title || 'Credit Risk Company'}
        </Typography>
        <CheckDetailTitle
          email={creditRiskCheck?.email}
          status={creditRiskCheck?.status}
          createdAt={creditRiskCheck?.createdAt}
          updatedAt={creditRiskCheck?.updatedAt}
        />
        <Typography variant="h4" sx={{ fontSize: '1rem', marginTop: '1rem' }}>
          No se encontraron datos.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1rem' }}>
          {creditRiskCheck?.checkDetails?.info || 'Información no disponible'}
        </Typography>
      </Box>
    )
  }

  return (
    <Box className="detail-group" sx={{ padding: '1.5rem' }}>
      <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1rem' }}>
        {title || 'Credit Risk Company'}
      </Typography>

      <CheckDetailTitle
        email={creditRiskCheck?.email}
        status={creditRiskCheck?.status}
        createdAt={creditRiskCheck?.createdAt}
        updatedAt={creditRiskCheck?.updatedAt}
      />

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Información del Documento
      </Typography>
      <Grid container spacing={1.5} sx={{ marginTop: '0.5rem' }}>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>ID Trámite Principal:</strong> {details?.id_tramite_principal || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>ID Tarjeta Reimpresa:</strong> {details?.id_tramite_tarjeta_reimpresa || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Ejemplar:</strong> {details?.ejemplar || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Vencimiento:</strong> {details?.vencimiento || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Emisión:</strong> {details?.emision || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>CUIL:</strong> {details?.cuil || '---'}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Datos Personales
      </Typography>
      <Grid container spacing={1.5} sx={{ marginTop: '0.5rem' }}>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Nombre:</strong> {details?.nombres || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Apellido:</strong> {details?.apellido || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Fecha de Nacimiento:</strong> {details?.fecha_nacimiento || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Nacionalidad:</strong> {details?.nacionalidad || '---'}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Dirección
      </Typography>
      <Grid container spacing={1.5} sx={{ marginTop: '0.5rem' }}>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Calle:</strong> {details?.calle || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Número:</strong> {details?.numero || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Ciudad:</strong> {details?.ciudad || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Provincia:</strong> {details?.provincia || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>País:</strong> {details?.pais || '---'}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Mensaje del Renaper
      </Typography>
      <Typography variant="body1" sx={{ marginTop: '0.5rem' }}>
        {details?.mensaje || '---'}
      </Typography>

      <Divider sx={{ margin: '1rem 0' }} />
    </Box>
  )
}

export default CheckCreditRisk
 */
